<template>
  <div>
    <div class="flex items-center space-x-6 mb-8">
      <button
        @click="tab = 'settings'"
        type="button"
        class="text-xl hoverable-static border-0 border-b-2 border-transparent border-solid"
        :class="{ 'border-orange': tab == 'settings' }"
      >
        <span class="hoverable-highlight">{{ _('cookies.settings') }}</span>
      </button>

      <button
        @click="tab = 'about'"
        type="button"
        class="text-xl hoverable-static border-0 border-b-2 border-transparent border-solid"
        :class="{ ' border-orange': tab == 'about' }"
      >
        <span class="hoverable-highlight">{{ _('cookies.about') }}</span>
      </button>
    </div>

    <div v-if="tab == 'about'" v-html="_('about')" class="my-6"></div>

    <div v-if="tab == 'settings'">
      <div class="grid gap-4">
        <Toggle
          :title="_('cookies.necessary')"
          :details="_('cookies.details')"
          :isActive="details == 'necessary'"
          :isLocked="true"
          :value="settings.necessary"
          @toggle="settings.necessary = !settings.necessary"
          @click="details = 'necessary'"
        />

        <Toggle
          :title="_('cookies.preferences')"
          :details="_('cookies.details')"
          :isActive="details == 'preferences'"
          :value="settings.preferences"
          @toggle="settings.preferences = !settings.preferences"
          @click="details = 'preferences'"
        />

        <Toggle
          :title="_('cookies.performance')"
          :details="_('cookies.details')"
          :isActive="details == 'performance'"
          :value="settings.performance"
          @toggle="settings.performance = !settings.performance"
          @click="details = 'performance'"
        />

        <Toggle
          :title="_('cookies.functional_preferences')"
          :details="_('cookies.details')"
          :isActive="details == 'functional_preferences'"
          :value="settings.functional"
          @toggle="settings.functional = !settings.functional"
          @click="details = 'functional_preferences'"
        />
      </div>

      <div class="my-6 py-4 border-0 border-t border-b border-solid border-black">
        <Details :data="data" :details="details" :options="options" />
      </div>
    </div>

    <div class="pt-6 pb-4 sticky bottom-0 bg-white text-center">
      <button
        type="button"
        class="bg-orange text-white rounded py-3 px-12"
        @click="$emit('write', settings)"
      >
        {{ _('cookies.btn.ok') }}
      </button>
    </div>
  </div>
</template>

<script>
import Details from './details';
import Toggle from './toggle';

export default {
  components: { Details, Toggle },

  props: {
    data: Object,
    options: Array
  },

  data() {
    return {
      tab: 'settings',
      details: 'necessary',
      settings: {
        necessary: true,
        preferences: false,
        performance: true,
        functional: false
      }
    };
  },

  methods: {
    _(key) {
      return this.data[key];
    }
  }
};
</script>
